import {ItemChip} from 'interface/base/ItemChip';
import {Tooltip} from 'interface/base/Tooltip';
import {Pressable, StyleSheet} from 'react-native';

interface ItemMovingProps {
  tip: 'top' | 'left';
}

export function ItemMoving({tip}: ItemMovingProps) {
  return (
    <Tooltip
      placement={tip === 'left' ? 'left' : 'top'}
      content="This file is being moved"
      showArrow>
      <Pressable style={styles.root}>
        <ItemChip
          label="Moving..."
          padding={{
            left: true,
            right: true,
          }}
        />
      </Pressable>
    </Tooltip>
  );
}

const styles = StyleSheet.create({
  root: {
    position: 'relative',
    cursor: 'default',
  },
});
